// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"44":"32a84bb0","318":"2c4a0c3e"}[chunkId] + ".css";
};